// Interface del usuario (GUI)
import {  Button, Fa, Card, CardImage, CardBody, CardTitle, CardText } from 'mdbreact';
// import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// React
import React, { Component } from 'react';

class Tarjeta extends Component {
  // constructor(props) {
  //   super(props)
  // } //fin de constructor

  render () {
    return (
      <Card cascade>
        <CardImage className="img-fluid" src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20%282%29.jpg" />
        <Button floating action><Fa icon="chevron-right"></Fa></Button>
        <CardBody>
            <CardTitle>Card title</CardTitle>
            <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText>
            <Button href="#">Button</Button>
        </CardBody>
        <div className="card-data">
            <ul>
                <li><Fa icon="clock-o"></Fa> 05/10/2015</li>
                <li><a href="#"><Fa icon="comments-o"></Fa>12</a></li>
                <li><a href="#"><Fa icon="facebook"> </Fa>21</a></li>
                <li><a href="#"><Fa icon="twitter"> </Fa>5</a></li>
            </ul>
        </div>
      </Card>
    ) //fin del return

  } //fin de render
} //fin de class

export default Tarjeta


// WEBPACK FOOTER //
// ./src/paginas/CascadingCard.js